import gql from 'graphql-tag';

export const getFacilityTypes = gql`
  query getFacilityTypes {
    getFacilityTypes {
      id
      name
    }
  }
`;
